import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import classes from "./Header.module.css";
import logo from '../../assets/logo.jpg';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`${classes.header} ${scrolled ? classes.scrolled : ""}`}>
      <div className={classes.topBar}>
        <span>
          <a href="tel:0559744760">0559744760</a>
        </span>
        <span>
          <a href="mailto:info@firstnumberfurniture.com?subject=Enquiry&body=Hello,">
            info@firstnumberfurniture.com
          </a>
        </span>
      </div>

      <nav className={classes.navbar}>
        <a href="/" className={classes.logoLink}>
          <div className={classes.logoFrame}>
            <img src={logo} alt="First Number Furniture IND LLC" className={classes.logoImg} />
          </div>
        </a>

        <button
          className={`${classes.hamburger} ${menuOpen ? classes.hamburgerOpen : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`${classes.navLinks} ${menuOpen ? classes.navOpen : ""}`}>
          <li><NavLink to="/about-us" className={({ isActive }) => isActive ? classes.activeLink : ""} onClick={closeMenu}>About Us</NavLink></li>
          <li><NavLink to="/services" className={({ isActive }) => isActive ? classes.activeLink : ""} onClick={closeMenu}>Services</NavLink></li>
          <li><NavLink to="/gallery" className={({ isActive }) => isActive ? classes.activeLink : ""} onClick={closeMenu}>Gallery</NavLink></li>
          <li>
            <NavLink to="/contact-us" className={`${classes.ctaLink} ${({ isActive }) => isActive ? classes.activeLink : ""}`} onClick={closeMenu}>
              Contact Us
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
